
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[airport]/agency/[agency]",
      function () {
        return require("private-next-pages/[airport]/agency/[agency]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[airport]/agency/[agency]"])
      });
    }
  